<div class="dx-field">
  <div class="dx-field-label">{{ 'Auch Master bearbeiten' | translate }}</div>
  <div class="dx-field-value">
    <dx-check-box [(value)]="editMaster"></dx-check-box>
  </div>
</div>

<div class="dx-field">
  <div class="dx-field-label">{{ 'Übernommene Preise aus Preislisten entfernen' | translate }}</div>
  <div class="dx-field-value">
    <dx-check-box [(value)]="removeConvertedPrices"></dx-check-box>
  </div>
</div>

<div class="dx-field" *ngIf="availablePriceTypes.length > 0">
  <div class="dx-field-label">{{ 'Preistypen' | translate }}</div>
  <div class="dx-field-value">
    <dx-tag-box
      [items]="availablePriceTypes"
      displayExpr="label"
      valueExpr="key"
      [(value)]="selectedPriceTypes"
      [showSelectionControls]="true"
      applyValueMode="useButtons"
      [searchEnabled]="false">
    </dx-tag-box>
  </div>
</div>

<p id="hintNoSupplier" *ngIf="noCatalogSupplier">{{"Im Katalog ist kein Lieferant eingetragen. Makro kann nicht ausgeführt werden."| translate}}</p>
